export default "__VITE_ASSET__f81b723f__"